/* eslint-disable no-nested-ternary */
import { Toolbar, Link } from '@mui/material';
import Router from 'next/router';

import { Button, Image } from '../shared';

const ErrorNavbar = () => {
    const onBookNowClick = () => {
        Router.push('/bookings').then(() => window.scrollTo(0, 0));
    };

    return (
        <div id="error-navbar-container">
            <Toolbar>
                <Link href="/" id="homii-logo-link" aria-label="HOMii Home">
                    <Image
                        src="/assets/images/homii_logo.png"
                        alt="HOMii Logo"
                        width={82.25}
                        height={22}
                    />
                </Link>
                <div id="error-navbar-spacer" />
                <Button id="book-now-error-button" onClick={onBookNowClick}>
                    Book Now
                </Button>
            </Toolbar>
        </div>
    );
};

export default ErrorNavbar;

